import React from "react";

const DynamicErrorModalContent = ({ title, message, errorCode }: { title: string, message: string, errorCode?: string }) => {
  return (
    <>
      <p className="bold abyss-blue font-size-xl mb-8">{title}</p>
      <p className="font-size-lg marengo-grey leading-8">{message}</p>
      {errorCode && <p className="font-size-md mb-0 marengo-grey font-size-lg">(Code: {errorCode})</p>}
    </>
  );
}

export default DynamicErrorModalContent;